module.exports = __webpack_public_path__ + "20d80feefa8ae691628d0f932e655826.jpg";